import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { addEventDiscussionReply, getEventDiscussionCommentReplies, setLoadingCommentIdReplies } from 'features/events/eventSlice'
import TimeAgo from 'components/utils/LocalizedTimeAgo'
import { FaReply } from "react-icons/fa";
import { LiaCommentsSolid } from "react-icons/lia";
import { LuSend } from "react-icons/lu";
import { pBtnSmall } from 'components/main.styled'
import { useTranslation } from 'react-i18next'


export default function DiscussionCommentItem(props) {
    const { t } = useTranslation('events')
    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.auth)
    const [viewReplies, setViewReplies] = useState(false) 
    const [createReply, setCreateReply] = useState(false)
    const [reply, setReply] = useState('')

    const { 
        eventDiscussionComments, 
        commentIndexLoading,
        commentRepliesSuccess,
        commentRepliesLoading,
        commentIdReplies,
        commentIdsOfRepliesLoaded
    } = useSelector((state) => state.events)


    const handleViewReplies = () => { 
        //check if replies are loaded
        // if not loaded, dispatch getEventDiscussionCommentReplies

        dispatch(setLoadingCommentIdReplies({
            commentId: props.data._id,
            index: props.index,
            loading: true,
            status: 'loading',
        }))

        if(!viewReplies){
            // if the replies are not loaded, dispatch getEventDiscussionCommentReplies

            if(!commentIdsOfRepliesLoaded.includes(props.data._id)){
                dispatch(getEventDiscussionCommentReplies({
                    commentId: props.data._id,
                    repliesArrayList: props.data.replies,
                    index: props.index,
                })) 
            }else if(commentIdsOfRepliesLoaded.includes(props.data._id)){
                // in redux, we store the commentIds for which replies have been loaded
                setViewReplies(true)
            
                dispatch(setLoadingCommentIdReplies({
                    commentId: props.data._id,
                    index: props.index,
                    loading: false,
                    status: 'success',
                }))
            }            
        }else{
            setViewReplies(false)
        }
    }

    useEffect(() => {
        if(commentRepliesSuccess && commentIdReplies === props.data._id){
            if(eventDiscussionComments[props.index].repliesLoaded === props.data._id){
                setViewReplies(true)
            }           
            else{
                setViewReplies(false)
            } 
        }
    }, [eventDiscussionComments, commentRepliesSuccess, commentIdReplies, props.data._id, props.index])

    const handleCreateReply = () => {
        const replyText = reply.trim()
        if (replyText.length < 3) return
        dispatch(addEventDiscussionReply({
            discussionCommentId : props.data._id,
            authorId: user._id,
            replyingTo: props.data.authorName,
            displayName: user.fullName,
            reply: replyText,
            index: props.index,
        }))
        setReply('')
        setCreateReply(false)
    }

    let newDate = new Date(props.data.createdAt)

    return (
        <ComItemCont>
            <CommentRow>
                <TGImage>
                    {props.data.author?.profileImg?.url
                        ? <img src={props.data.author.profileImg.url} alt="" />
                        : <span>{(props.data.authorName || '?').charAt(0).toUpperCase()}</span>}
                </TGImage>
                <TG>
                <TopCommentSection>
                    <TopLeftSection>
                        <HeadingText>{props.data.authorName}</HeadingText>
                    </TopLeftSection>

                    <TopRightSection>
                        <CommentDate><TimeAgo datetime={newDate}/></CommentDate>
                    </TopRightSection>
                </TopCommentSection>

                <CommentText>{props.data.comment}</CommentText>
                <Btns>
                    {props.data.replies.length > 0 && (
                        <CommentButton
                            type="button"
                            disabled={commentRepliesLoading}
                            onClick={handleViewReplies}
                            >
                                <LiaCommentsSolid style={{ marginRight: '5px', fontSize: '14px'}} />

                                {
                                    // ((commentIndexLoading.commentId === props.data._id)
                                    // && 
                                    // (commentIndexLoading.status === 'loading') ) ? ('loading') :
                                    (
                                        viewReplies ? t('discussion.hideReplies') : t('discussion.viewReplies')
                                    )
                                }
                        </CommentButton>  
                    )}                      
                    <CommentButton 
                        type="button"
                        onClick={() => setCreateReply(!createReply)}>
                            <FaReply style={{ marginRight: '5px', fontSize: '14px'}} /> {t('discussion.reply')}
                    </CommentButton>
                </Btns>
                </TG>
            </CommentRow>
            {
                createReply && (
                    <ReplyInputWrap>
                        <ReplyInput 
                            type="text" 
                            placeholder={t('discussion.addReply')}
                            value={reply}
                            onChange={(e) => setReply(e.target.value)}
                            /> 
                        <ReplyButton
                            type="button"
                            disabled={reply.trim().length < 3}
                            onClick={handleCreateReply}
                            >
                                <LuSend  />
                        </ReplyButton>
                    </ReplyInputWrap>
                )
            }   
            {

                (
                    viewReplies &&
                    commentIndexLoading.commentId === props.data._id && 
                    commentIndexLoading.status === 'success'
                ) 
                && 
                (
                    <RepliesContainer>
                        <h2>{t('discussion.replies')}</h2>
                        {
                        props.data.replies.map((ele) => (
                                <TGWrap key={ele._id}>
                                    <TGImage>
                                        {ele.author?.profileImg?.url
                                            ? <img src={ele.author.profileImg.url} alt="" />
                                            : <span>{(ele.authorName || '?').charAt(0).toUpperCase()}</span>}
                                    </TGImage>
                                    <TG
                                        $isReply={true}
                                        >
                                        <TopCommentSection>
                                            <TopLeftSection> 
                                                <HeadingText>{ele.authorName}</HeadingText>
                                            </TopLeftSection>
                                            <TopRightSection>
                                                <CommentDate><TimeAgo datetime={new Date(ele.createdAt)}/></CommentDate>
                                            </TopRightSection>
                                        </TopCommentSection>
                                        <CommentText>{ele.reply}</CommentText>
                                    </TG>
                                </TGWrap>
                            ))
                        }
                    </RepliesContainer>
                )
            }
   
        </ComItemCont>
    )
}

const TGWrap = styled.div` 
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;

`
const TGImage = styled.div`
    width: 34px;
    height: 34px;
    flex: 0 0 34px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    overflow: hidden;
    background: rgba(0, 180, 204, .14);
    color: var(--themeColor);
    font-size: 13px;
    font-weight: 800;
    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`

const ComItemCont = styled.div`
    width: 100%;  
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start; 
    padding: 12px 4px 4px;
`

const CommentRow = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 9px;
`

const TG = styled.div` 
    width: ${props => props.$isReply ? 'auto' : '100%'};
    flex: ${props => props.$isReply ? '0 1 auto' : '1'};
    min-width: 0;
    margin-bottom: ${props => props.$isReply ? '4px' : '0'};
    max-width: ${props => props.$isReply ? 'calc(100% - 44px)' : '100%'};
    padding: ${props => props.$isReply ? '10px 12px' : '11px 12px 9px'};
    height: fit-content;
    border: 1px solid ${props => props.$isReply ? '#e3e9eb' : '#e1e7e9'};
    border-radius: 13px;
    display: flex;
    flex-direction: column;
    text-align: left; 
    background-color: #ffffff;
    box-shadow: ${props => props.$isReply ? 'none' : '0 2px 8px rgba(31, 46, 51, .04)'};
`

const TopCommentSection = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

`

const TopLeftSection = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-right: 10px;
`

const TopRightSection = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`
const CommentDate = styled.div`
    flex-shrink: 0;
    font-size: 10px;
    color: #8a9599;
`

const CommentText = styled.div`
    padding-top: 7px;
    font-size: 13px;
    line-height: 1.5;
    color: var(--lightThemeFontColor);
    white-space: pre-wrap;
    overflow-wrap: anywhere;
`

const HeadingText = styled.div` 
    overflow: hidden;
    font-weight: 700;
    font-size: 12px;
    color: var(--lightThemeFontColor);
    text-overflow: ellipsis;
    white-space: nowrap;
`

const Btns = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 5px;
    margin-top: 7px;
`

const CommentButton = styled(pBtnSmall)`    
    min-height: 28px;
    padding: 0 8px;
    border-radius: 8px;
    background: transparent;
    color: #6f7c80;
    font-size: 10px;
    &:hover{ 
        background-color: #eef3f4;
        color: var(--themeColor);
    }
`

const RepliesContainer = styled.div`
    width: 100%;
    height: fit-content;  
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    margin: 8px 0 0 43px;
    background-color: transparent;
    padding: 0;
    max-height: 300px;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 0px;
        background: transparent; 
    }
    -ms-overflow-style: none; 
    scrollbar-width: none; 

    h2{
        margin: 0 0 1px 42px;
        text-align: left;
        font-size: 10px;
        font-weight: 800;
        letter-spacing: .08em;
        text-transform: uppercase;
        color: #859195;
    }
`

const ReplyInputWrap = styled.div` 
    margin: 8px 0 0 43px;
    width: calc(100% - 43px);
    padding: 5px 6px 5px 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    border: 1px solid #dfe6e8;
    border-radius: 11px;
    background-color: #ffffff;
`

const ReplyButton = styled(pBtnSmall)` 
    width: 32px;
    height: 32px;
    padding: 0;
    border: 0;
    border-radius: 9px;
    font-size: 13px; 
    color: ${props => props.disabled ? 'grey' : 'white'}; 
    background-color: ${props => props.disabled ? '#e7ecee' : 'var(--themeColor)'};

    &:hover{
        filter: ${props => props.disabled ? 'none' : 'brightness(.94)'};
    } 
`
 
const ReplyInput = styled.input`
    background-color: transparent;
    border: none;
    outline: none;
    width: 100%;
    padding: 5px;
    color: var(--lightThemeFontColor);
    font-size: 12px;
`
